import axios from "axios";

export const api = axios.create({
    baseURL: 'https://struct-hotel-api.herokuapp.com/api/v1/'
})